// Components/GuestData.jsx
export const guestColumns = [
  { Header: "S.No", accessor: "sno" },
  { Header: "Name", accessor: "name" },
  { Header: "Mobile", accessor: "mobile_no" },
  { Header: "Email", accessor: "email" },
  { Header: "ID Type", accessor: "identity_type" },
  { Header: "ID Number", accessor: "identity_no" },
  { Header: "VIP", accessor: "is_vip" },
  { Header: "Blacklisted", accessor: "is_blacklisted" },
  { Header: "Actions", accessor: "actions" },
];
